"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/tree-select/style/css");

var _treeSelect = _interopRequireDefault(require("antd/es/tree-select"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

require("./topicBadgeFilter.scss");

const {
  SHOW_PARENT
} = _treeSelect.default;
const initialState = {
  selectedTopicIds: []
};

class TopicBadgeFilter extends _react.default.Component {
  constructor(props) {
    super(props);

    this.onTopicsSelectedChange = selectedIds => {
      const {
        selectedTopicsChanged,
        topics
      } = this.props;
      const selectedTopics = topics.filter(t => selectedIds.includes(t.id));
      const selectedParentTopics = selectedTopics.filter(t => t.children && t.children.length);
      const selectedChildTopicIds = selectedParentTopics.map(t => t.children).reduce((children, current) => current ? children.concat(current) : children, []).map(t => t.id);
      const selectedTopicIds = (0, _lodash.union)(selectedParentTopics.map(t => t.id), selectedTopics.map(t => t.id), selectedChildTopicIds, selectedIds);
      this.setState({
        selectedTopicIds
      }, () => {
        selectedTopicsChanged(selectedTopicIds);
      });
    };

    this.state = { ...initialState,
      selectedTopicIds: props.selectedTopicIds
    };
  }

  render() {
    const {
      topics
    } = this.props;
    const {
      selectedTopicIds
    } = this.state;

    if (!topics || topics.length === 0) {
      return /*#__PURE__*/_react.default.createElement("div", null, "No Topics");
    }

    const treeData = topics.map(topic => {
      const articleCount = topic.children ? topic.children.reduce((sum, curr) => sum + curr.articleCount, 0) : 0;
      return {
        title: `${topic.title} (${articleCount})`,
        value: topic.id,
        key: topic.id,
        children: topic.children ? topic.children.map(child => {
          return {
            title: `${child.title} (${child.articleCount})`,
            value: child.id,
            key: child.id
          };
        }) : []
      };
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-topic-badge-filter"
    }, /*#__PURE__*/_react.default.createElement(_treeSelect.default, {
      treeData: treeData,
      value: selectedTopicIds,
      onChange: this.onTopicsSelectedChange,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      placeholder: "Please select a topic",
      allowClear: true,
      showSearch: false,
      style: {
        width: '100%'
      }
    }));
  }

}

var _default = TopicBadgeFilter;
exports.default = _default;